import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonsModule } from '@shared/core/components/buttons';
import { SubNavModule } from '@shared/core/components/subNav';
import { SearchForProductsFilterModule } from '@shared/core/components/search/searchTypes/forProductsFilter';

import { OnlineMenuNavForMobileComponent } from './online-menu-nav-for-mobile.shared.component';

@NgModule({
    declarations: [
        OnlineMenuNavForMobileComponent
    ],
    imports: [
        CommonModule,
        SubNavModule,
        ButtonsModule,
        SearchForProductsFilterModule,
    ],
    exports: [
        OnlineMenuNavForMobileComponent
    ],
})
export class OnlineMenuNavForMobileModule { }
